import { MessageTemplateDetailsState } from "@idw-types/state/message-template-details-state";
import { MessageTemplateDetailsActions, MessageTemplateDetailsActionTypes } from "@redux/actions/message-template-details-actions";

export const initialMessageTemplateDetailsState: MessageTemplateDetailsState = {
    messageTemplate: {
        isLoading: false,
        messageTemplate: null
    }
};

export const messageTemplateDetailsReducer = (
    state: MessageTemplateDetailsState = initialMessageTemplateDetailsState,
    action: MessageTemplateDetailsActions
): MessageTemplateDetailsState => {
    switch (action.type) {
        // Message Template Details
        case MessageTemplateDetailsActionTypes.SET_MESSAGE_TEMPLATE_DETAILS_LOADING:
            return {
                ...state,
                messageTemplate: {
                    ...(action.payload.isLoading
                        ? { ...initialMessageTemplateDetailsState.messageTemplate }
                        : { ...state.messageTemplate }),
                    isLoading: action.payload.isLoading
                }
            };
        case MessageTemplateDetailsActionTypes.SET_MESSAGE_TEMPLATE_DETAILS:
            return {
                ...state,
                messageTemplate: {
                    messageTemplate: action.payload.messageTemplate,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};